export default {
  ACCESS_ARTICLE_ADMIN: 'ACCESS_ARTICLE_ADMIN',
  CREATE_ARTICLE: 'CREATE_ARTICLE',
  EDIT_THIS_ARTICLE: 'EDIT_THIS_ARTICLE',
  MANAGE_EDITORS: 'MANAGE_EDITORS',
  PUBLISH_TEAM_CONTENT: 'PUBLISH_TEAM_CONTENT',
  REVIEW_AND_PUBLISH: 'REVIEW_AND_PUBLISH',
  VIEW_ADMIN_MENU: 'VIEW_ADMIN_MENU',
};
